import { FurnitureNavBar } from '@/components/furniture/FurnitureNavBar';
import { FurnitureStaffingPage } from './FurnitureStaffingPage';

/**
 * Outer shell for /furniture-projects/staffing — wraps the staffing UI in
 * the same backdrop + nav bar used by the projects list, so the section
 * feels like one cohesive sub-app.
 */
export default function FurnitureStaffingShell() {
  return (
    <div className="min-h-screen bg-[#fbfaf7]">
      <FurnitureNavBar />
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <FurnitureStaffingPage />
      </div>
    </div>
  );
}
